import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);
const routerPC: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/pc/Home.vue"),
    redirect: "/Login",
    children: [
      {
        path: "/Login",
        name: "Login",
        component: () => import("@/views/pc/user/Login.vue"),
      },
      {
        path: "/SetPassword",
        name: "SetPassword",
        component: () => import("@/views/pc/user/SetPassword.vue"),
      },
    ],
  },
  {
    path: "/MainFrame",
    name: "MainFrame",
    component: () => import("@/views/pc/MainFrame.vue"),
    //redirect: '/PstQuery',
    children: [
      // super
      {
        path: "/Import",
        name: "Import",
        component: () => import("@/views/pc/super/PstImport.vue"),
      },
      // {
      //   path: '/NetMessage',
      //   name: 'NetMessage',
      //   component: () => import('@/views/pc/super/NetMessage.vue'),
      // },
      {
        path: "/Transfers",
        name: "Transfers",
        component: () => import("@/views/pc/super/Transfers.vue"),
      },

      {
        path: "/ReplyAudits",
        name: "ReplyAudits",
        component: () => import("@/views/pc/super/ReplyAudits.vue"),
      },
      {
        path: "/Transfer/:id",
        name: "Transfer",
        component: () => import("@/views/pc/super/Transfer.vue"),
      },
      {
        path: "/ReplyAudit/:id",
        name: "ReplyAudit",
        component: () => import("@/views/pc/super/ReplyAudit.vue"),
      },
      {
        path: "/PstQuery",
        name: "PstQuery",
        component: () => import("@/views/pc/super/PstQuery.vue"),
      },
      {
        path: "/Details/:id",
        name: "Details",
        component: () => import("@/views/pc/super/Details.vue"),
      },
      //负面舆情列表-平台管理员审核
      {
        path: "/PstAudits",
        name: "PstAudits",
        component: () => import("@/views/pc/super/PstAudits.vue"),
      },
      {
        path: "/PstAudit",
        name: "PstAudit",
        component: () => import("@/views/pc/super/PstAudit.vue"),
      },
      {
        path: "/AIAnalysis",
        name: "AIAnalysis",
        component: () => import("@/views/pc/super/AIAnalysis.vue"),
      },
      // manager
      {
        path: "/Replys",
        name: "Replys",
        component: () => import("@/views/pc/manager/Replys.vue"),
      },
      {
        path: "/Reply/:id",
        name: "Reply",
        component: () => import("@/views/pc/manager/Reply.vue"),
      },
      {
        path: "/ReportPrint/:id",
        name: "ReportPrint",
        component: () => import("@/views/pc/manager/ReportPrint.vue"),
      },
      {
        path: "/Evidences",
        name: "Evidences",
        component: () => import("@/views/pc/manager/Evidences.vue"),
      },
      {
        path: "/Evidence/:id",
        name: "Evidence",
        component: () => import("@/views/pc/manager/Evidence.vue"),
      },
      {
        path: "/Negatives",
        name: "Negatives",
        component: () => import("@/views/pc/manager/Negatives.vue"),
      },
      {
        path: "/Negative",
        name: "Negative",
        component: () => import("@/views/pc/manager/Negative.vue"),
      },
      {
        path: "/EditNegative/:id",
        name: "EditNegative",
        component: () => import("@/views/pc/manager/EditNegative.vue"),
      },
      {
        path: "/NegativeDetail/:id",
        name: "NegativeDetail",
        component: () => import("@/views/pc/manager/NegativeDetail.vue"),
      },
      {
        path: "/HandleDetail/:id",
        name: "HandleDetail",
        component: () => import("@/views/pc/manager/HandleDetail.vue"),
      },
      {
        path: "/HandleQuery",
        name: "HandleQuery",
        component: () => import("@/views/pc/manager/HandleQuery.vue"),
      },
      //网络工单列表
      {
        path: "/PstCrawlers",
        name: "PstCrawlers",
        component: () => import("@/views/pc/super/PstCrawlers.vue"),
      },
      //admin
      {
        path: "/Parameter",
        name: "Parameter",
        component: () => import("@/views/pc/admin/Parameter.vue"),
      },
      {
        path: "/Supers",
        name: "Supers",
        component: () => import("@/views/pc/admin/Supers.vue"),
      },
      //单位管理
      {
        path: "/UnitManager",
        name: "UnitManager",
        component: () => import("@/views/pc/admin/UnitManager.vue"),
      },
      //用户管理
      {
        path: "/UserManager",
        name: "UserManager",
        component: () => import("@/views/pc/admin/UserManager.vue"),
      },
      //移除用户管理
      {
        path: "/MoveManager",
        name: "MoveManager",
        component: () => import("@/views/pc/admin/MoveManager.vue"),
      },
      //管理员管理
      {
        path: "/AddSuper",
        name: "AddSuper",
        component: () => import("@/views/pc/admin/AddSuper.vue"),
      },
      {
        path: "/EditSuper",
        name: "EditSuper",
        component: () => import("@/views/pc/admin/EditSuper.vue"),
      },
      {
        path: "/CrawlerParam",
        name: "CrawlerParam",
        component: () => import("@/views/pc/admin/CrawlerParam.vue"),
      },
      //user
      {
        path: "/Password",
        name: "Password",
        component: () => import("@/views/pc/user/Password.vue"),
      },

      {
        path: "/About",
        name: "About",
        component: () => import("@/views/pc/user/About.vue"),
      },
    ],
  },
];

export default routerPC;
